module.exports = __webpack_public_path__ + "static/media/timelapse_15.25624efc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_15.jpg
// module id = 973
// module chunks = 0